import { createElement } from 'react';
import { toPlainText } from '../../lib/contentSafety';
import { safeWebsite } from './programPresentation';

// Reconstruct only supported rich-text elements as React nodes. Never insert
// source HTML, attributes, styles, embedded media or executable markup.
const allowedTags = new Set(['p', 'br', 'strong', 'b', 'em', 'i', 'u', 's', 'strike', 'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'pre', 'code', 'hr', 'a']);
const discardTags = new Set(['script', 'style', 'iframe', 'object', 'embed', 'svg', 'math', 'template', 'noscript', 'form', 'input', 'button', 'textarea', 'select']);

const renderNode = (node, key) => {
  if (node.nodeType === 3) return node.textContent;
  if (node.nodeType !== 1) return null;
  const tag = node.tagName.toLowerCase();
  if (discardTags.has(tag)) return null;
  const children = Array.from(node.childNodes, (child, index) => renderNode(child, `${key}-${index}`));
  if (!allowedTags.has(tag)) return children;
  const props = { key };
  if (tag === 'a') {
    const href = safeWebsite(node.getAttribute('href'));
    if (!href) return children;
    props.href = href;
    props.rel = 'noopener noreferrer';
  }
  // Organizer headings stay subordinate to the About section heading.
  const renderedTag = /^h[1-6]$/.test(tag) ? 'h3' : tag;
  return createElement(renderedTag, props, ...children);
};

const hasVisibleText = node => {
  if (typeof node === 'string') return Boolean(node.trim());
  if (Array.isArray(node)) return node.some(hasVisibleText);
  return node?.props?.children ? hasVisibleText(node.props.children) : false;
};

export default function ProgramDescription({ value }) {
  if (!toPlainText(value)) return <p className="detail-description">Description not provided.</p>;
  if (!/<\/?[a-z][^>]*>/i.test(value) || typeof DOMParser === 'undefined') {
    return <div className="detail-description">{value.split(/\r?\n\s*\r?\n/).map((paragraph, index) => <p key={index}>{paragraph}</p>)}</div>;
  }
  const parsed = new DOMParser().parseFromString(value, 'text/html');
  const content = Array.from(parsed.body.childNodes, (node, index) => renderNode(node, index));
  if (!hasVisibleText(content)) return <p className="detail-description">Description not provided.</p>;
  return <div className="detail-description detail-rich-description">{content}</div>;
}
